module.exports = __webpack_public_path__ + "static/media/map-marker.79f0fc6a.svg";